import {
  HTTP_GETBUDGETCOMPSBYDEPT_FETCHING,
  HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS,
  HTTP_GETBUDGETCOMPSBYDEPT_FAILED,
  HTTP_RESET_GETBUDGETCOMPSBYDEPT,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETCOMPSBYDEPT_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPSBYDEPT_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
